import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  viewChild,
} from '@angular/core';
import { UserService } from '../../services/user-service/user.service';

@Component({
  selector: 'greeting',
  template: `
    <h1 #greetingEl class="home__greeting">Welcome, {{ name() }}.</h1>
    <p class="home__subtitle">What do you want to do today?</p>
  `,
  styleUrl: './greeting.scss',
})
export class Greeting implements AfterViewInit {
  userService = inject(UserService);
  userDetails = this.userService.getUserDetails().data;
  name = computed(() => {
    return this.userDetails()?.displayName ?? '-';
  });

  private readonly greetingEl = viewChild.required<ElementRef<HTMLElement>>('greetingEl');
  // Cached so getBoundingClientRect() never runs inside the hot mousemove path
  private greetingRect = { left: 0, width: 1 };
  private gleamX = 0;
  private gleamRaf: number | null = null;

  ngAfterViewInit() {
    setTimeout(() => this.cacheGreetingRect(), 0);
  }

  @HostListener('window:resize')
  cacheGreetingRect() {
    const greetingEl = this.greetingEl();
    if (!greetingEl) return;
    const r = greetingEl.nativeElement.getBoundingClientRect();
    this.greetingRect = { left: r.left, width: r.width };
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    this.gleamX = e.clientX; // always store latest X
    if (!this.greetingEl() || this.gleamRaf) return;
    this.gleamRaf = requestAnimationFrame(() => {
      this.gleamRaf = null;
      const pct = Math.max(
        0,
        Math.min(100, ((this.gleamX - this.greetingRect.left) / this.greetingRect.width) * 100),
      );
      this.greetingEl().nativeElement.style.setProperty('--gleam', ~~pct + '');
    });
  }
}
